import markUrl from "../assets/logo-mark.png";
import wordmarkUrl from "../assets/logo-wordmark.png";
import { cx } from "./primitives";

/**
 * The UnizPay logo (artwork in brand/, web sizes built by scripts/build-brand-assets.py).
 * `wordmark` is the mark with "UNIZPAY"; `mark` is the symbol alone. Size it with a height class
 * (default h-7); the width follows.
 */
export function Logo({
  variant = "wordmark",
  className,
}: { variant?: "wordmark" | "mark"; className?: string }) {
  return (
    <img
      src={variant === "mark" ? markUrl : wordmarkUrl}
      alt="UnizPay"
      draggable={false}
      className={cx("inline-block h-7 w-auto select-none", className)}
    />
  );
}
